import { CSSProperties, ReactNode } from "react"
import classNames from "classnames"

import styles from "./styles.module.scss"

const Loading = ({
  loading = false,
  children = null,
  containerClassName,
  containerStyles,
}: {
  loading: boolean
  children?: ReactNode
  containerClassName?: string
  containerStyles?: CSSProperties
}) => {
  if (!loading) {
    return <>{children}</>
  }

  return (
    <div
      className={classNames(styles["spinner-container"], containerClassName)}
      data-testid="customer-attachments-loading"
      style={containerStyles}>
      <i className={styles.spinner} />
    </div>
  )
}

export default Loading
